import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Box,
  Typography,
  TextField,
  Button,
  Modal,
  IconButton,
  MenuItem,
  FormControl,
  Select,
  RadioGroup,
  Radio,
  FormControlLabel,
} from "@mui/material";
import { API_URL } from "../components/Constant";
import Header from "../components/Header";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import Keyboard from "../components/Keyboard";
import Colors from "../components/Colors";

const GameName = () => {
  const [gameName, setGameName] = useState("");
  const [gameNameError, setGameNameError] = useState("");
  const [category, setCategory] = useState("");
  const [serverMode, setServerMode] = useState("");
  const [isEdit, setIsEdit] = useState(false);
  const [gameMode, setGameMode] = useState("Daily Puzzle");
  const [configResult, setConfigResult] = useState([]);
  const [serverResult, setServerResult] = useState([]);

  useEffect(() => {
    const storedGameName = localStorage.getItem("gameId");
    const storedCategory = localStorage.getItem("category");
    const servertype = localStorage.getItem("server");

    if (storedGameName) {
      setGameName(storedGameName);
      setIsEdit(true);
    }

    if (storedCategory) {
      setCategory(storedCategory);
      setIsEdit(true);
    }
    if (servertype) {
      setServerMode(servertype);
      setIsEdit(true);
    }
  }, []);

  const handleAddName = async () => {
    console.log("gameName", gameName);
    console.log("category", category);
    console.log(isEdit);
    if (!isEdit) {
      try {
        const response = await axios.post(`${API_URL}/add_name`, {
          gameId: gameName,
          CreatorTocken: localStorage.getItem("CreatorTocken"),
        });
        console.log(response.data);
        if (response.data.success === true) {
          localStorage.setItem("gameId", gameName);
          localStorage.setItem("category", category);
          localStorage.setItem("server", serverMode);
          window.location.href = "/crossword-creator";
        } else {
          setGameNameError("Game name already exists");
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    } else {
      if (gameName !== localStorage.getItem("OldGameName"))
        try {
          const response = await axios.post(`${API_URL}/add_name`, {
            gameId: gameName,
            CreatorTocken: localStorage.getItem("CreatorTocken"),
          });
          console.log(response.data);
          if (response.data.success === true) {
            try {
              const response = await axios.post(`${API_URL}/update_name`, {
                gameId: gameName,
                OldGameName: localStorage.getItem("OldGameName"),
                CreatorTocken: localStorage.getItem("CreatorTocken"),
              });
              console.log(response.data);
              if (response.data.success === true) {
                localStorage.setItem("gameId", gameName);
                localStorage.setItem("category", category);
                localStorage.setItem("server", serverMode);
                window.location.href = "/crossword-creator";
              }
            } catch (error) {
              console.error("Error fetching data:", error);
            }
          } else {
            setGameNameError("Game name already exists");
          }
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      else {
        localStorage.setItem("gameId", gameName);
        localStorage.setItem("category", category);
        window.location.href = "/crossword-creator";
      }
    }
  };

  const handleGameModeChange = (e) => {
    const selectedMode = e.target.value;
    setGameMode(selectedMode);
    localStorage.setItem("Gamemode", selectedMode);
  };

  useEffect(() => {
    if (gameMode === "Daily Puzzle") {
      const fetchGameScoreData = async () => {
        try {
          const response = await axios.post(
            `${API_URL}/select_creator_category`,
            {
              CreatorTocken: localStorage.getItem("CreatorTocken"),
            },
          );
          console.log(response.data.configData);
          setConfigResult(response.data.configData);
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      };
      fetchGameScoreData();
    } else if (gameMode === "Rapid Riddle") {
      // Static categories for 'rapid riddle' mode
      setConfigResult([
        { type: "Ramadan" },
        { type: "Easter" },
        { type: "Movie" },
      ]);
    }
  }, [gameMode]);

  useEffect(() => {
    const fetchGameServerData = async () => {
      try {
        const response = await axios.get(`${API_URL}/select_server_mode`);
        console.log(response.data.configData);
        setServerResult(response.data.configData);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchGameServerData();
  }, []);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "16px",
        width: "100%",
        height: "100%",
        minHeight: "100vh",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Header />
      {/* <Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px', padding: '16px',
                 justifyContent: 'flex-start', alignItems: 'flex-start', width: '100%', maxWidth:'90%',  }}>
                   <Typography variant="h6" gutterBottom>
                       Choose your game category:
                    </Typography>
                    <FormControl fullWidth sx={{background:'white',}}>
        <Select value={category}
         onChange={(e) => setCategory(e.target.value)}
       
         MenuProps={{
         
          MenuListProps: {
            sx: {
             
              '& .MuiMenuItem-root': {
               '&:hover': {
                  backgroundColor: Colors.button2, color:'#FFF',
                },
                '&.Mui-selected': {
                  backgroundColor: Colors.button2, color:'#FFF',
                  '&:hover': {
                    backgroundColor: Colors.button2, color:'#FFF',
                  },

                },
              },
            },
          },
        }}>
          <MenuItem value="Tiny Thinkers">Tiny Thinkers</MenuItem>
          <MenuItem value="Master Minds">Master Minds</MenuItem>
          <MenuItem value="Logic Legends">Logic Legends</MenuItem>
          <MenuItem value="Back To Bench">Back To Bench</MenuItem>
        </Select>
      </FormControl>
              <Keyboard setGameName = {setGameName} gameName = {gameName}></Keyboard> 
              <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: '16px', width:'100%'  }}>
                    <Button 
                      onClick={() => {handleAddName()}} 
                      sx={{
                        background: Colors.button1,
                        color: '#fff',
                       width: '120px',
                        border: '1px solid ',
                        borderColor:Colors.button1,
                        borderRadius: '8px',
                        cursor: 'pointer',
                        fontSize: '12px',
                        transition: 'background 0.3s, transform 0.3s',
                        '&:hover': { 
                          background: Colors.button1,
                          transform: 'scale(1.05)',
                        },
                        '&:active': {
                          background: Colors.button1,
                        },
                      }}
                    >
                      Proceed
                    </Button>
                    <Button
                      onClick={() => window.location.reload()} 
                      sx={{
                        background: Colors.button2,
                        color: '#fff',
                        width: '120px',
                        border: '1px solid',
                        borderColor:Colors.button2,
                        borderRadius: '8px',
                        cursor: 'pointer',
                        fontSize: '12px',
                        transition: 'background 0.3s, transform 0.3s',
                        '&:hover': { 
                          background: Colors.button2,
                          transform: 'scale(1.05)',
                        },
                        '&:active': {
                          background: Colors.button2,
                        },
                      }}
                    >
                     Clear
                    </Button>
                  </Box>
                   {gameNameError && <Typography sx={{color:'red', fontFamily:'Roboto', fontSize:{xs:'12px', md:'14px'}, fontWeight:400}}>
                                                       {gameNameError}</Typography>}
            </Box> */}

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "16px",
          padding: "16px",
          justifyContent: "flex-start",
          alignItems: "flex-start",
          width: "100%",
          maxWidth: "90%",
        }}
      >
        {/* Radio Buttons for Game Type */}
        <FormControl component="fieldset">
          <Typography
            variant="body1"
            sx={{ fontWeight: "bold", marginBottom: "8px" }}
          >
            Select Game Mode:
          </Typography>
          <RadioGroup row value={gameMode} onChange={handleGameModeChange}>
            <FormControlLabel
              value="Daily Puzzle"
              control={
                <Radio
                  sx={{
                    color: Colors.Tidesfont,
                    "&.Mui-checked": {
                      color: Colors.Tidesfont, // Change color when selected
                    },
                  }}
                />
              }
              label="Daily Puzzle"
            />
            <FormControlLabel
              value="Rapid Riddle"
              control={
                <Radio
                  sx={{
                    color: Colors.Tidesfont,
                    "&.Mui-checked": {
                      color: Colors.Tidesfont, // Change color when selected
                    },
                  }}
                />
              }
              label="Rapid Riddle"
            />
          </RadioGroup>
        </FormControl>
        <Typography variant="h6" gutterBottom>
          Choose your game category:
        </Typography>
        <FormControl fullWidth sx={{ background: "white" }}>
          <Select
            value={category}
            onChange={(e) => setCategory(e.target.value)}
            MenuProps={{
              MenuListProps: {
                sx: {
                  "& .MuiMenuItem-root": {
                    "&:hover": {
                      background: Colors.button2,
                      color: Colors.button2font,
                    },
                    "&.Mui-selected": {
                      background: Colors.button2,
                      color: Colors.button2font,
                      "&:hover": {
                        background: Colors.button2,
                        color: Colors.button2font,
                      },
                    },
                  },
                },
              },
            }}
          >
            {configResult.map((item) => (
              <MenuItem key={item.type} value={item.type}>
                {item.type}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <Typography variant="h6" gutterBottom>
          Choose your Server:
        </Typography>
        <FormControl fullWidth sx={{ background: "white" }}>
          <Select
            value={serverMode}
            onChange={(e) => setServerMode(e.target.value)}
            MenuProps={{
              MenuListProps: {
                sx: {
                  "& .MuiMenuItem-root": {
                    "&:hover": {
                      background: Colors.button2,
                      color: Colors.button2font,
                    },
                    "&.Mui-selected": {
                      background: Colors.button2,
                      color: Colors.button2font,
                      "&:hover": {
                        background: Colors.button2,
                        color: Colors.button2font,
                      },
                    },
                  },
                },
              },
            }}
          >
            {serverResult.map((item) =>
              item.value.split(", ").map((subValue) => (
                <MenuItem key={subValue} value={subValue}>
                  {subValue}
                </MenuItem>
              )),
            )}
          </Select>
        </FormControl>

        <Keyboard setGameName={setGameName} gameName={gameName} />
        {gameNameError && (
          <Typography
            sx={{
              color: "red",
              fontFamily: "Roboto",
              fontSize: { xs: "12px", md: "14px" },
              fontWeight: 400,
            }}
          >
            {gameNameError}
          </Typography>
        )}

        {/* Buttons Section */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "16px",
            width: "100%",
          }}
        >
          <Button
            onClick={handleAddName}
            sx={{
              background: Colors.button1,
              color: Colors.button1font,
              width: "120px",
              border: "1px solid ",
              borderColor: Colors.button1Border,
              borderRadius: "8px",
              cursor: "pointer",
              fontSize: "12px",
              transition: "background 0.3s, transform 0.3s",
              "&:hover": {
                background: Colors.button1,
                transform: "scale(1.05)",
              },
              "&:active": {
                background: Colors.button1,
              },
            }}
          >
            Proceed
          </Button>
          <Button
            onClick={() => window.location.reload()}
            sx={{
              background: Colors.button2,
              color: Colors.button2font,
              width: "120px",
              border: "1px solid",
              borderColor: Colors.button2,
              borderRadius: "8px",
              cursor: "pointer",
              fontSize: "12px",
              transition: "background 0.3s, transform 0.3s",
              "&:hover": {
                background: Colors.button2,
                transform: "scale(1.05)",
              },
              "&:active": {
                background: Colors.button2,
              },
            }}
          >
            Clear
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default GameName;
